import * as React from 'react';
import { Check, Copy } from 'lucide-react';
import { cn } from '../lib/utils';
import { useUiStrings } from '../lib/ui-strings';

export function useCopy(timeout = 1500) {
  const [copied, setCopied] = React.useState(false);
  const copy = React.useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        window.setTimeout(() => setCopied(false), timeout);
      } catch {
        setCopied(false);
      }
    },
    [timeout],
  );
  return { copied, copy };
}

/** 等宽 ID + 复制按钮。 */
export function CopyId({
  value,
  display,
  className,
}: {
  value: string;
  display?: string;
  className?: string;
}) {
  const { copied, copy } = useCopy();
  const strings = useUiStrings();
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        void copy(value);
      }}
      className={cn(
        'group inline-flex min-h-6 max-w-full items-center gap-1.5 rounded-sm font-mono text-xs text-muted-foreground transition-colors hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
        className,
      )}
      aria-label={strings.copyValue(value)}
      title={value}
    >
      <span className="truncate">{display ?? value}</span>
      {copied ? (
        <Check className="size-3.5 shrink-0 text-success" aria-hidden />
      ) : (
        <Copy className="size-3.5 shrink-0 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100" aria-hidden />
      )}
      <span className="sr-only" aria-live="polite">
        {copied ? strings.copied : ''}
      </span>
    </button>
  );
}
